/**
 * Classic L: long brick bulwarks (docs/spec/03 §2). Each gap is plugged by a boulder on a steel
 * sill with a pit beyond: push it through. By the middle bulwark a firefly waits under a fuse.
 */

import type { CaveDef } from '../types';

export const caveL: CaveDef = {
  id: 'L',
  name: 'BULWARKS',
  hint: 'Walls have weak spots. Some you push, one you blast.',
  intermission: false,
  colors: [2, 12, 1],
  diamondValue: 20,
  extraValue: 40,
  fill: { base: '.', items: [['r', 12], ['d', 7]] },
  levels: [
    { seed: 2501, diamonds: 15, time: 150 },
    { seed: 2502, diamonds: 18, time: 140 },
    { seed: 2503, diamonds: 21, time: 130 },
    { seed: 2504, diamonds: 24, time: 120 },
    { seed: 2505, diamonds: 27, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...??????w??.....wrw?????????w????????W',
    'W.P.??????w??.....wrw?????????w????????W',
    'W...????..w.......wrw?????????w????????W',
    'W???????..r ........w?????????w???d.d??W',
    'W???????..W ....... w???d.d???w????????W',
    'W???????..w....f    w?????????w????????W',
    'W?????????w??.. ... w???????..w..??????W',
    'W??d.d????w??.. ... w???????..r .??????W',
    'W?????????w??.. ... w???????..W .??????W',
    'W?????????w??.. ... w???????..w..??????W',
    'W?????????w??..     w?????????w????????W',
    'W?????????w??.......w?????????w????dd??W',
    'W?????????w?????????w?????????w????????W',
    'W???????..w..???????w????dd???w????????W',
    'W???????..r .???????w???????..w..??????W',
    'W???????..W .???????w???????..r .??????W',
    'W????dd?..w..?????..w..?????..W .??????W',
    'W?????????w???????..r .?????..w..??????W',
    'W?????????w???????..W .???????w?????X??W',
    'W?????????w???????..w..???????w????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
